import React, { useEffect, useState } from 'react';

import { DropdownFilter, Input, Title } from '@fnacdarty/back-office-ui';
import PropTypes from 'prop-types';

import {
	StyledFilterContainer,
	StyledDropdownContainer,
	StyledHeader,
	StyledList,
	StyledItem,
	StyledListContainer,
	StyledInput,
	StyledDropdown,
	StyledFilterList,
} from './index.styled';
import { getUser } from '../../../authentication/utils/auth';
import { StyledInputSearchContainer } from '../../../activity/components/ActivityFilter/index.styled';
import { StyledSearchIcon } from '../CalendarContainer/index.styled';
import { filterBySkillsAndSectors } from '../../utils/calendar';

const CalendarFilter = ({
	filters,
	setFilters,
	selectedResource,
	setSelectedResource,
	changeFiliale,
	isVersionPC,
	refreshData,
}) => {
	const { roles = [] } = getUser();
	const [diplayedResources, setDisplayedResources] = useState(
		filters.resources,
	);
	const [searchResources, setSearchedResource] = useState('');

	const updateSkills = (newSkills) => {
		const newResources = filters.resources.map((resource) => {
			resource.skills.map((skill) => {
				let selected = false;
				newSkills.forEach((newSkill) => {
					if (skill.id === newSkill.id && newSkill.selected) {
						selected = true;
					}
				});
				return {
					...skill,
					selected,
				};
			});
			return resource;
		});
		setFilters({
			...filters,
			resources: newResources,
		});
	};

	const updateSectors = (newSectors) => {
		setFilters({
			...filters,
			sectors: newSectors,
		});
	};

	useEffect(() => {
		// filters resource by skills and sectors selected
		const filteredResources = filterBySkillsAndSectors(filters);
		setDisplayedResources(filteredResources);
	}, [filters.skills, filters.sectors, filters.resources, changeFiliale]);

	useEffect(() => {
		// filters resource by search
		if (searchResources.length === 0) {
			const filteredResources = filterBySkillsAndSectors(filters);
			setDisplayedResources(filteredResources);
		} else {
			const filteredResources = diplayedResources.filter((resource) =>
				resource.code
					.toLowerCase()
					.includes(searchResources.toLowerCase()),
			);
			setDisplayedResources(filteredResources);
		}
	}, [searchResources]);

	const setOptions = (newOptions) => {
		const newResources = diplayedResources.map((resource) => {
			let selected = false;

			newOptions.forEach((newOption) => {
				if (resource.id === newOption.id && newOption.selected) {
					setSelectedResource(resource);
				}
			});

			if (selectedResource?.code) {
				selected = resource.code === selectedResource.code;
			}
			if (selectedResource?.name) {
				const nameResource = resource.name
					? resource.name
					: resource.code;
				selected = nameResource === selectedResource.name;
			}

			return {
				...resource,
				selected,
			};
		});
	};
	const updatedResources = filters.resources.map((resource) => {
		if (
			resource.id === selectedResource.id &&
			resource.code === selectedResource.code
		) {
			return { ...resource, selected: true };
		}
		return { ...resource, selected: false };
	});

	return (
		<>
			{isVersionPC() && (
				<StyledFilterContainer>
					{roles?.length > 0 &&
						roles.includes('ROLE_CUISINE_INTERNE') && (
							<>
								<StyledHeader>
									<Title level={3}>Filtrer par</Title>
									<hr />
								</StyledHeader>
								<StyledDropdownContainer>
									<DropdownFilter
										title="Compétences"
										identifier="id"
										label="code"
										options={filters?.skills || []}
										setOptions={updateSkills}
										multiSelect={true}
									/>
								</StyledDropdownContainer>
								<StyledDropdownContainer>
									<DropdownFilter
										title="Secteurs"
										label="code"
										identifier="id"
										options={filters?.sectors || []}
										setOptions={updateSectors}
										multiSelect={true}
									/>
								</StyledDropdownContainer>
							</>
						)}
					<StyledDropdownContainer>
						{filters.resources.length > 0 && (
							<StyledList>
								<StyledInputSearchContainer>
									<StyledInput
										type="text"
										value={searchResources}
										placeholder="Rechercher..."
										onChange={(e) => {
											setSearchedResource(e.target.value);
										}}
									/>
									<StyledSearchIcon
										name="search"
										width={20}
									/>
								</StyledInputSearchContainer>
								<StyledListContainer>
									{diplayedResources.map((resource) => {
										let selected = false;
										if (selectedResource?.code) {
											selected =
												resource.code ===
												selectedResource.code;
										}
										if (selectedResource?.name) {
											const nameResource = resource.name
												? resource.name
												: resource.code;
											selected =
												nameResource ===
												selectedResource.name;
										}

										return (
											<StyledItem
												key={resource.id}
												onClick={() => {
													setSelectedResource(
														resource,
													);
												}}
												$selected={selected}
											>
												<span>{resource.code}</span>
											</StyledItem>
										);
									})}
								</StyledListContainer>
							</StyledList>
						)}
					</StyledDropdownContainer>
				</StyledFilterContainer>
			)}
			{!isVersionPC() && (
				<StyledDropdown>
					<StyledFilterList>
						<Title level={4}>
							Planning{' '}
							{selectedResource?.code
								? selectedResource?.code
								: selectedResource?.name}
						</Title>
					</StyledFilterList>

					<DropdownFilter
						title=""
						identifier="id"
						label="code"
						options={updatedResources}
						setOptions={setOptions}
						multiSelect={false}
						showIcon={true}
						icon="menu"
					/>
				</StyledDropdown>
			)}
		</>
	);
};

export default CalendarFilter;

CalendarFilter.propTypes = {
	filters: PropTypes.object.isRequired,
	setFilters: PropTypes.func.isRequired,
	selectedResource: PropTypes.object.isRequired,
	setSelectedResource: PropTypes.func.isRequired,
	changeFiliale: PropTypes.string,
	isVersionPC: PropTypes.func,
	refreshData: PropTypes.bool,
};
